import React, { useState, useEffect, useContext} from "react"
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import 'moment/locale/fr'
import {
  Box,
  Container,
  Button,
  Hidden,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelCircleIcon from '@material-ui/icons/Cancel';
import HelpCircleIcon from '@material-ui/icons/Help';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

import ViewResultsModal from "../ui/ViewResultsModal"

import PopupNotifContext from "../../contexts/PopupNotifContext"

import getInitials from '../../utils/getInitials';
import APIS from "../../utils/APIS"

moment.locale("fr");


const RecruiterUserRows = ({ userList, actScan }) => {

  const [modalViewResults, setModalViewResults] = useState(false)

  const { addPopupNotif } = useContext(PopupNotifContext)

  return (
    <>
      <Table>
        <TableBody>
          {userList?.map((user, index) => {
            let resultForThisUser = actScan?.userResults?.find((el) => el?.userID === user?.userID)

            let progress = 0
            let statut = "notStarted"
            let result = "En attente"
            let colorResult = "black"
            let IconResult = HelpCircleIcon
            if (resultForThisUser) {
              progress = resultForThisUser?.progress
              if (resultForThisUser?.progress === 100 && resultForThisUser?.isDone === true) {
                statut = "ended"

                if (resultForThisUser?.validationResult === true) {
                  IconResult = CheckCircleIcon
                  colorResult = "#38B000"
                  result = "Compatible"
                } else if (resultForThisUser?.validationResult === false) {
                  IconResult = CancelCircleIcon
                  colorResult = "#FC3040"
                  result = "Incompatible"
                }
              } else {
                statut = "inProgress"
              }
            }
            return (
              <React.Fragment key={index}>
                <TableRow
                  sx={{
                    height:["65px", "72px", "72px"],
                    background:"white",
                    border:"1px solid #E7E7E7",
                    userSelect:"none",
                    "&: hover": {
                      cursor: statut === "ended" ? "pointer" : "default",
                      border: statut === "ended" ? "1px solid black" : "1px solid #E7E7E7",
                    },
                    "& .MuiTableCell-root" : {
                      border:0,
                    }
                  }}
                  onClick={() => {
                    if(statut === "ended") {
                      setModalViewResults(user)
                    }
                  }}
                >
                  <Hidden smDown>
                    <TableCell sx={{
                      padding:"12px",
                      paddingRight:0,
                      width:["41px", "48px", "48px"],
                    }}>
                      <Box sx={{
                        width:["41px", "48px", "48px"],
                        maxWidth:["41px", "48px", "48px"],
                        height:["41px", "48px", "48px"],
                        background:"black",
                        color:"white",
                        textTransform:"uppercase",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        fontWeight:500,
                        fontSize:["14px", "20px", "20px"],
                        overflow:"hidden",
                      }}>
                        {user?.actived === "true" ? (
                          <>{getInitials(user?.userName)}</>
                        ) : (
                          <>{getInitials(user?.userEmail)}</>
                        )}
                      </Box>
                    </TableCell>
                  </Hidden>
                  <TableCell sx={{
                    padding:"12px",
                    paddingRight:0,
                  }}>
                    <Box sx={{
                      display:"flex",
                      flexDirection:["column", "column", "row"],
                      alignItems:["flex-start", "flex-start", "center"],
                      gap:["2px", "2px", "6px"],
                    }}>
                      {user?.actived === "true" &&
                        <Box sx={{
                          fontWeight:500,
                          fontSize:["16px", "20px", "20px"],
                          color:"text.black",

                        }}>
                          {user?.userName}
                        </Box>
                      }
                      <Box sx={{
                        fontWeight:400,
                        fontSize:["12px", "16px", "16px"],
                        color:"text.primary",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        whiteSpace:"nowrap",
                      }}>
                        {user?.userEmail}
                      </Box>
                    </Box>
                  </TableCell>
                  <Hidden smDown>
                    <TableCell sx={{
                      padding:"12px",
                      paddingRight:0,
                    }}>
                      <Box sx={{
                        display:"flex",
                        flexDirection:"column",
                        maxWidth:"250px",
                      }}>
                        <Box sx={{display:"flex", justifyContent:"space-between", gap:"10px"}}>
                          <Box sx={{
                            fontWeight:400,
                            fontSize:"14px",
                            color:"text.primary",
                          }}>
                            Progression
                          </Box>
                          <Box sx={{
                            fontWeight:400,
                            fontSize:"14px",
                            color:"text.black",
                          }}>
                            {statut === "notStarted" && "--"}
                            {statut === "inProgress" && `${progress}%`}
                            {statut === "ended" && `${progress}%`}
                          </Box>
                        </Box>
                        <Box sx={{
                          height:"5px",
                          marginTop:"5px",
                          background:"#D9D9D9",
                          position:"relative"
                        }}>
                          <Box sx={{
                            height:"5px",
                            marginTop:"5px",
                            background:"black",
                            position:"absolute",
                            top:"-5px",
                            left:0,
                            width:`${progress}%`,
                          }}>
                          </Box>
                        </Box>
                      </Box>
                    </TableCell>
                  </Hidden>
                  <TableCell sx={{
                    padding:"12px",
                    paddingRight:["12px", 0, 0],
                    textAlign:"right"
                  }}>
                    <Box sx={{
                      fontWeight:400,
                      fontSize:["14px", "14px", "15px"],
                      display:"flex",
                      alignItems:"center",
                      color:colorResult,
                      gap:"5px",
                      justifyContent:"flex-end",
                    }}>
                      <Hidden mdDown>
                        <span style={{color:"#565656", whiteSpace:"nowrap"}}>Résultat :</span>
                        <IconResult sx={{width:"20px", height:"20px", marginTop:"-3px"}}/>
                        <span style={{whiteSpace:"nowrap", color:"black"}}>{result}</span>
                      </Hidden>
                      <Hidden smDown mdUp>
                        <IconResult sx={{width:"18px", height:"18px"}}/>
                        <span style={{whiteSpace:"nowrap", color:"black"}}>{result}</span>
                      </Hidden>
                      <Hidden xsDown smUp>
                      {statut === "notStarted" ? (
                        <MailOutlineIcon sx={{
                          paddingTop:"5px",
                          height:"30px",
                          width:"20px",
                          visibility: "visible",
                          cursor:"pointer"
                        }}/>
                      ) : (
                        <IconResult sx={{width:"20px", height:"20px"}}/>
                      )}
                      </Hidden>
                    </Box>
                  </TableCell>
                  <Hidden smDown>
                    <TableCell sx={{
                      padding:"12px",
                      paddingRight:0,
                      width:["0px", "55px", "55px"],
                      minWidth:["0px", "55px", "55px"],
                    }}>
                      {statut === "ended" &&
                        <ChevronRightIcon sx={{
                          paddingTop:"5px",
                          height:"40px",
                          width:"40px",
                          visibility: "visible",
                        }}/>
                      }
                      {statut === "inProgress" &&
                        <ChevronRightIcon sx={{
                          paddingTop:"5px",
                          height:"40px",
                          width:"40px",
                          visibility: "hidden",
                        }}/>
                      }
                      {statut === "notStarted" &&
                        <MailOutlineIcon
                          onClick={() => {
                            let closeDate = moment(actScan?.plan?.plan[0]?.closeDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
                            APIS.reInvitCandidat({email : user?.userEmail, groupeID : actScan?.id, closeDate : closeDate}).then((result) => {
                              if (result?.message === "reInvitCandidat") {
                                addPopupNotif({
                                  uuid : uuidv4(),
                                  text : user?.userEmail+" a bien été réinvité !",
                                  type : "confirmation",
                                  removeAfter:5000,
                                })
                              } else {
                                addPopupNotif({
                                  uuid : uuidv4(),
                                  text : "Erreur !",
                                  type : "error",
                                  removeAfter:5000,
                                })
                              }
                            })
                          }}
                          sx={{
                            paddingTop:"5px",
                            height:"30px",
                            width:"40px",
                            visibility: "visible",
                            cursor:"pointer"
                          }}
                        />
                      }
                    </TableCell>
                  </Hidden>
                </TableRow>
                <TableRow sx={{
                  height:["7px", "10px", "13px"],
                }} />
              </React.Fragment>
            )
          })}
        </TableBody>
      </Table>

      <ViewResultsModal
        isOpen={modalViewResults === false ? false : true}
        actScan={actScan}
        user={modalViewResults}
        onClose={() => setModalViewResults(false) }
        type="recruiter"
      />
    </>
  )
};

export default RecruiterUserRows;
